<template>
	<div>
		<el-row>
			<el-col v-if="channelSelectedNames.length > 0" :span="21">
				<div ref="channel_content" :class="isShowAllChannel ? 'showChannelAll' : 'showChannelNotAll'">
					<el-tag v-for="item in channelSelectedNames" :key="item.id" size="small" style="margin: 5px 5px">
						{{ item.name }}
					</el-tag>
				</div>
			</el-col>
			<el-col v-if="choiceChannelHeight > 40" :span="21" style="display: flex; justify-content: center">
				<el-button
					:icon="isShowAllChannel ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
					class="btn_add_channel"
					type="text"
					@click="isShowAllChannel = !isShowAllChannel">
					{{ isShowAllChannel ? '收起' : '展开' }}
				</el-button>
			</el-col>
			<el-col v-if="!isReadOnly">
				<el-button icon="el-icon-plus" type="primary" @click="onAddChannel">新增渠道</el-button>
			</el-col>
		</el-row>

		<el-dialog
			:visible.sync="isShowChoiceChannel"
			append-to-body
			center
			modal-append-to-body
			title="选择渠道"
			top="8vh"
			width="55%"
			@close="onCloseChannelDlg">
			<el-alert
				:closable="false"
				show-icon
				style="margin-bottom: 20px"
				title="选择左侧可选渠道后，点击【到右边】按钮，则选中渠道，选择右侧已选渠道，点击【到左边】按钮，则取消渠道"
				type="warning"></el-alert>
			<virtual-transfer
				v-model="channelSelectedList"
				:button-texts="['到左边', '到右边']"
				:data="channelCanSelectList"
				:can-select-list="channelCanSelectList"
				:props="valueChange"
				:titles="['可选渠道', '已选渠道']"
				filterable
				@change="onChannelChange"
				@import-channels="onImportChannels"></virtual-transfer>
			<template slot="footer">
				<el-button size="small" style="margin: 0 20px" type="primary" @click="onChoiceChannelCancel">取消</el-button>
				<el-button size="small" style="margin: 0 20px" type="primary" @click="onChoiceChannel">确定</el-button>
			</template>
		</el-dialog>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'

import {getChannels} from '@/api/insurance/settlement'
import VirtualTransfer from '@/components/common/VirtualTransfer'

export default {
	name: 'choiceChannel',
	mixins: [],
	components: {
		VirtualTransfer,
	},
	props: {
		interType: {
			type: String,
			default: 'settle',
		},
		reqType: {
			type: String,
			default: 'ruleAward',
		},
		rulesId: {
			type: String,
			default: '0',
		},
		isReadOnly: {
			type: Boolean,
			default: false,
		},
		channelSelected: {
			type: Array,
			default: () => {
				return []
			},
		},
	},
	data() {
		return {
			isShowChoiceChannel: false,
			isClickChannelInsure: false,
			choiceChannelHeight: 0,
			//可选渠道
			channelCanSelectList: [],
			//已经渠道ID
			channelSelectedList: [],
			channelDataChoiceTemp: [],
			//界面展示渠道名字
			channelSelectedNames: [],
			isShowAllChannel: false,
			//转换
			valueChange: {
				key: 'id',
				label: 'name',
			},
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
	},
	watch: {
		channelSelected: {
			handler(val = [], old) {
				this.channelSelectedNames = val
				if (this.interType === 'coupon') {
					//优惠券进入
					this.onGetSelectIds()
				}
				this.getScrollHeight()
			},
			immediate: true,
		},
		isReadOnly(val, old) {
			//改变可读状态
			this.isReadOnly = val
		},
	},
	created() {},
	mounted() {
		//判断是否为只展示
		if (this.isReadOnly && this.channelSelected.length > 0) {
			this.channelSelectedNames = this.channelSelected
			this.getScrollHeight()
		} else {
			this.getChannelsData()
		}
	},
	methods: {
		/**
		 * 获取可选渠道数据
		 */
		getChannelsData() {
			//获取可以选择的渠道，以及已选渠道
			let query = {}
			if (this.rulesId !== '0') {
				query.id = this.rulesId
			}
			getChannels(this.reqType, query).then((response) => {
				//获取数据
				let {canSelectList, selectedList} = response.data.data
				if (canSelectList.length === 0 && selectedList.length === 0 && !this.isReadOnly) {
					this.$message.error('适用渠道数据为空')
					return
				}
				if (selectedList && selectedList.length > 0) {
					//处理 排序
					this.channelCanSelectList = canSelectList.concat(selectedList).sort((a, b) => {
						return a.id - b.id
					})
					//带名字的
					this.channelSelectedNames = selectedList
					this.channelSelectedList = selectedList.map((itemData) => {
						return itemData.id
					})
					//发送选中
					this.$emit('onChannelSelected', this.channelSelectedList)
					this.getScrollHeight()
				} else {
					//新增
					this.channelCanSelectList = canSelectList
				}
			})
		},

		/**
		 * 处理数据
		 */
		onGetSelectIds() {
			this.channelSelectedList = this.channelSelectedNames.map((itemData) => {
				return itemData.id
			})
		},

		/**
		 * 只可读！
		 */
		setOnlyReadyView() {},

		/**
		 * 选中渠道确认
		 */
		onChoiceChannel() {
			//获取展示的name
			this.channelSelectedNames = []
			if (this.channelSelectedList.length > 0) {
				for (let channelDataAllElement of this.channelCanSelectList) {
					if (this.channelSelectedList.includes(channelDataAllElement.id)) {
						this.channelSelectedNames.push(channelDataAllElement)
					}
				}
			}
			this.isShowChoiceChannel = false
			this.isClickChannelInsure = true
			this.$emit('onChannelSelected', this.channelSelectedList)
		},

		/**
		 * 新增渠道
		 */
		onAddChannel() {
			//备份选中的数据
			this.channelDataChoiceTemp = this.deepClone(this.channelSelectedList)
			this.isShowChoiceChannel = true
		},

		/**
		 * 取消选择渠道
		 */
		onChoiceChannelCancel() {
			this.isShowChoiceChannel = false
		},

		/**
		 * 渠道选择变化处理
		 * @param {Array} value - 新的选中值
		 * @param {string} direction - 移动方向
		 * @param {Array} movedKeys - 移动的key数组
		 */
		onChannelChange(value, direction, movedKeys) {
			// 虚拟滚动Transfer组件的change事件处理
			console.log('渠道选择变化:', {value, direction, movedKeys})
		},

		/**
		 * 渠道关闭回调
		 */
		onCloseChannelDlg() {
			if (!this.isClickChannelInsure) {
				this.channelSelectedList = this.deepClone(this.channelDataChoiceTemp)
				this.channelDataChoiceTemp = []
			}
			this.isClickChannelInsure = false
			if (this.channelSelectedNames.length > 0) {
				this.getScrollHeight()
			} else {
				this.choiceChannelHeight = 0
			}
		},

		/**
		 * 获取所选数据
		 * @returns {Array}
		 */
		getSelectedNames() {
			return this.channelSelectedNames || []
		},

		/**
		 * 获取高度
		 */
		getScrollHeight() {
			setTimeout(() => {
				this.$nextTick(() => {
					if (this.$refs.channel_content) {
						this.choiceChannelHeight = this.$refs.channel_content.scrollHeight
					}
				})
			}, 400)
		},

		/**
		 * 导入渠道
		 */
		onImportChannels(channels) {
			// 处理导入的渠道
			console.log('导入的渠道:', channels)
			//将导入的渠道添加到可选渠道中
			this.channelCanSelectList = channels
			//将导入的渠道添加到已选渠道中
			this.channelSelectedList = channels.map((item) => {
				return item.id
			})
		},
	},
	activated() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {},
	beforeRouteEnter(to, from, next) {
		next()
	},
	beforeRouteUpdate(to, from, next) {
		next()
	},
	beforeRouteLeave(to, from, next) {
		next()
	},
}
</script>

<style lang="scss" scoped>
.showChannelAll {
	height: auto !important;
}

.showChannelNotAll {
	height: 30px !important;
	overflow: hidden;
}

::v-deep .virtual-transfer {
	justify-content: center;
}

::v-deep .virtual-transfer-panel {
	width: 300px !important;
}

::v-deep .virtual-transfer-buttons {
	margin-top: 120px;
}
</style>
